export var TelemetryExportAuthMode;
(function (TelemetryExportAuthMode) {
    TelemetryExportAuthMode["TELEMETRY_EXPORT_AUTH_MODE_GCP_SECRET_MANAGER"] = "GCP_SECRET_MANAGER";
})(TelemetryExportAuthMode || (TelemetryExportAuthMode = {}));
